export default __webpack_public_path__ + "static/134-min-min-303c0451f8b8a8eb3ae82d36ab113fc0.jpg";